import { AsyncPipe, CurrencyPipe } from '@angular/common';
import { Component, DestroyRef, inject, OnDestroy, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { TranslocoPipe } from '@jsverse/transloco';
import { SavingsPlanFacade } from '@zero/saving-plans/domain';
import { BackLinkComponent, InstrumentDetailsLinkComponent, WatchlistToggleComponent } from '@zero/shared/ui-web-components';
import { ButtonComponent, IconButtonComponent } from '@zero/shared/ui-web-design-system';
import { AuthService } from '@zero/shared/util-web-app-services';
import { filter } from 'rxjs';

@Component({
  imports: [
    TranslocoPipe,
    AsyncPipe,
    CurrencyPipe,
    InstrumentDetailsLinkComponent,
    WatchlistToggleComponent,
    IconButtonComponent,
    ButtonComponent,
    BackLinkComponent,
  ],
  templateUrl: './savings-plan-preview.component.html',
  styleUrl: './savings-plan-preview.component.scss',
})
export class SavingsPlanPreviewComponent implements OnInit, OnDestroy {
  public readonly facade = inject(SavingsPlanFacade);
  readonly #destroyRef = inject(DestroyRef);
  readonly #authService = inject(AuthService);

  public readonly isPotentialCustomer$ = this.#authService.isPotentialCustomer();

  public currentlyDeletingId: string | null = null;

  ngOnInit(): void {
    this.facade.loadOnboardingSavingsPlans();

    this.facade.onboardingSavingsPlanDeleted$
      .pipe(
        filter((deleted) => !!deleted),
        takeUntilDestroyed(this.#destroyRef),
      )
      .subscribe(() => {
        this.facade.loadOnboardingSavingsPlans();
        this.#clearCache();
      });
  }

  ngOnDestroy(): void {
    this.#clearCache();
  }

  readonly #clearCache = () => {
    this.facade.clearOnboardingSavingsPlanDeletionState();
    this.currentlyDeletingId = null;
  };
}
